"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgIcon = _interopRequireDefault(require("../../components/SvgIcon"));
var _default = exports["default"] = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(_SvgIcon["default"], Object.assign({
    viewBox: '0 0 16 16'
  }, props, {
    ref: ref
  }), /*#__PURE__*/_react["default"].createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(-1189.000000, -142.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(1169.000000, 130.000000)"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(20.000000, 12.000000)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8,11.5 C7.724,11.5 7.5,11.276 7.5,11 L7.5,8.5 L5,8.5 C4.724,8.5 4.5,8.276 4.5,8 C4.5,7.724 4.724,7.5 5,7.5 L7.5,7.5 L7.5,5 C7.5,4.724 7.724,4.5 8,4.5 C8.276,4.5 8.5,4.724 8.5,5 L8.5,7.5 L11,7.5 C11.276,7.5 11.5,7.724 11.5,8 C11.5,8.276 11.276,8.5 11,8.5 L8.5,8.5 L8.5,11 C8.5,11.276 8.276,11.5 8,11.5 Z",
    id: "Path"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8,16 C3.58866667,16 0,12.4113333 0,8 C0,3.58866667 3.58866667,0 8,0 C12.4113333,0 16,3.58866667 16,8 C16,12.4113333 12.4113333,16 8,16 Z M8,1 C4.14,1 1,4.14 1,8 C1,11.86 4.14,15 8,15 C11.86,15 15,11.86 15,8 C15,4.14 11.86,1 8,1 Z",
    id: "Shape"
  }))))));
});